import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import OrgAdminNonNationalResultRelease from '../../../modules/result/@org-admin/results-release/OrgAdminNonNationalResultRelease';

const OrgAdminNonNationalExaminationResults = () => (
  <>
    <TitleHeader title="Non-National Examination Results" />

    <ContentTemplate type="full">
      <OrgAdminNonNationalResultRelease />
    </ContentTemplate>
  </>
);
export default OrgAdminNonNationalExaminationResults;
